import {
	calculateDensity,
	getOneDecimalFormattedNumber,
} from '../../../constants'
import { } from '../../SearchPanel/templateUtils'
import moment from 'moment'
import {
	getBase64Decoded,
	getFromSessionStorage,
} from '../../../utils/StorageUtils'

export const getBookingResponseMapper = (bookingDetails, isToBeProcessedCase) => {

	let unidInfoArray = [];
	bookingDetails?.dangerousGoodsInformation?.filter(item => {

		unidInfoArray.push({
			id: item?.id,
			unid: item?.unid,
			shippingName: item?.properShippingName,
			packingGroup: item?.packingGroup
		})

	})

	const dgSccCode = JSON.parse(getFromSessionStorage('dgsccCode'))
	let sccCodesArr = [];
	if (Array.isArray(bookingDetails?.sccCodes)) {
		sccCodesArr = bookingDetails.sccCodes;
	} else if (typeof bookingDetails?.sccCodes === 'string') {
		sccCodesArr = bookingDetails.sccCodes.split(',').map(e => e.trim());
	}
	const dgCheck = sccCodesArr.some(e => dgSccCode?.includes(e));
	// const dgCheck = bookingDetails?.sccCodes?.some(e => dgSccCode?.includes(e))
	const dgCheckNormal = getFromSessionStorage('ifDg')

	let responseBody = {
		awb: bookingDetails.shipmentIdentifierDetails
			? bookingDetails.shipmentIdentifierDetails
			: '',
		origin:
			bookingDetails.shipmentDetails &&
				bookingDetails.shipmentDetails.shipmentOrigin
				? bookingDetails.shipmentDetails.shipmentOrigin
				: '',
		destination:
			bookingDetails.shipmentDetails &&
				bookingDetails.shipmentDetails.shipmentDestination
				? bookingDetails.shipmentDetails.shipmentDestination
				: '',
		shippingDate:
			bookingDetails.shipmentDetails &&
				bookingDetails.shipmentDetails.shippingDate
				? getFormattedDate(bookingDetails.shipmentDetails.shippingDate)
				: '',
		arrivalDate:
			bookingDetails.shipmentDetails &&
				bookingDetails.shipmentDetails.arrivalDate
				? getFormattedDate(bookingDetails.shipmentDetails.arrivalDate)
				: '',
		bookingStatus: bookingDetails.bookingStatus
			? bookingDetails.bookingStatus
			: '',
		weightUnit: bookingDetails.weightUnit,
		volumeUnit: bookingDetails.volumeUnit,
		dimensionUnit: bookingDetails.dimensionUnit,
		rate: bookingDetails.ratingDetails ? bookingDetails.ratingDetails[0].rate : '',
		sccCodes: Array.isArray(bookingDetails.sccCodes)
			? bookingDetails.sccCodes
			: (typeof bookingDetails.sccCodes === 'string' && bookingDetails.sccCodes.length > 0)
				? bookingDetails.sccCodes.split(',').map(code => code.trim())
				: [],
		// sccCodes: bookingDetails.sccCodes,
		dropOffAddress: bookingDetails.shipmentDetails
			? bookingDetails.shipmentDetails.dropOffAddress
			: null,
		pickUpAddress: bookingDetails.shipmentDetails
			? bookingDetails.shipmentDetails.pickUpAddress
			: null,
		bookingCargoDetails: {
			quantity:
				bookingDetails.shipmentDetails &&
					bookingDetails.shipmentDetails.totalNumberOfPieces
					? bookingDetails.shipmentDetails.totalNumberOfPieces
					: '-',
			grossWeight: isToBeProcessedCase ? (bookingDetails?.shipmentDetails?.totalWeight || bookingDetails?.bookingCommodityDetails?.at(0)?.weight) : (bookingDetails.shipmentDetails
				? bookingDetails.shipmentDetails.totalWeight
				: '-'),
			volume:
				bookingDetails.bookingCommodityDetails != null &&
					bookingDetails.bookingCommodityDetails.lenth !== 0
					? bookingDetails.bookingCommodityDetails[0].volume
					: '-',
			density:
				bookingDetails.bookingCommodityDetails != null &&
					bookingDetails.bookingCommodityDetails.lenth !== 0 &&
					bookingDetails.bookingCommodityDetails[0].volume !== 0
					? calculateDensity(
						bookingDetails.bookingCommodityDetails[0].volume,
						bookingDetails.shipmentDetails.totalWeight
					)
					: 0,

			product:
				bookingDetails?.shipmentDetails &&
					bookingDetails?.shipmentDetails?.productDetails
					? bookingDetails?.shipmentDetails?.productDetails?.productDescription ?? (isToBeProcessedCase ? bookingDetails?.shipmentDetails?.productDetails?.productName : bookingDetails?.productName)
					: bookingDetails?.productName || '',
			commodity: bookingDetails.bookingCommodityDetails[0].shipmentDescription,
			shipmentScc: Array.isArray(bookingDetails.sccCodes)
				? bookingDetails.sccCodes
				: (typeof bookingDetails.sccCodes === 'string' && bookingDetails.sccCodes.length > 0)
					? bookingDetails.sccCodes.split(',').map(code => code.trim())
					: '-',
			service:
				(() => {
					let sccCodesArr = [];
					if (Array.isArray(bookingDetails.sccCodes)) {
						sccCodesArr = bookingDetails.sccCodes;
					} else if (typeof bookingDetails.sccCodes === 'string' && bookingDetails.sccCodes.length > 0) {
						sccCodesArr = bookingDetails.sccCodes.split(',').map(code => code.trim());
					}
					return bookingDetails.sccCodes && getService(sccCodesArr)
						? getService(sccCodesArr)
						: '--';
				})(),
			// bookingDetails.sccCodes && getService(bookingDetails.sccCodes)
			// 	? getService(bookingDetails.sccCodes)
			// 	: '--',
		},
		bookingFlightDetails: bookingDetails.bookingFlightDetails,
		bookingRateDetails: bookingDetails ? bookingDetails.ratingDetails : null,
		chargeDetails: {
			chargeableWeight:
				bookingDetails.bookingCommodityDetails != null &&
					bookingDetails.bookingCommodityDetails[0].chargeableWeight != null
					? getOneDecimalFormattedNumber(
						bookingDetails.bookingCommodityDetails[0].chargeableWeight
					)
					: '',
			rate:
				bookingDetails.ratingDetails != null &&
					bookingDetails.ratingDetails[0].rate != null
					? bookingDetails.ratingDetails[0].rate
					: 0,
			airFreightCost:
				bookingDetails.ratingDetails != null &&
					bookingDetails.ratingDetails[0].freightCharge != null
					? bookingDetails.ratingDetails[0].freightCharge
					: 0,
			// ...existing code...
			totalSurcharges:
				bookingDetails.ratingDetails?.[0]?.totalOtherCharge ??
				(bookingDetails.otherChargeDetails?.reduce((sum, charge) => sum + (charge.otherChargeAmount || 0), 0) || 0),
			// ...existing code...
			surcharges:
				bookingDetails.ratingDetails != null &&
					bookingDetails.otherChargeDetails != null
					? bookingDetails.otherChargeDetails
					: 0,
			// ...existing code...
			currencyCode:
				bookingDetails?.shipmentDetails?.currency ||
				(bookingDetails.ratingDetails?.[0]?.currency ?? ''),
			totalCost:
				bookingDetails.ratingDetails?.[0]?.totalCharge ??
				(bookingDetails.ratingDetails?.[0]?.freightCharge || 0) +
				(bookingDetails.otherChargeDetails?.reduce((sum, charge) => sum + (charge.otherChargeAmount || 0), 0) || 0),
			spotRate: bookingDetails.spotRate !== null ? bookingDetails.spotRate : 0,
			allInRate: bookingDetails.allInRate,
			spotRateStatus:
				bookingDetails.spotRate !== null || bookingDetails.spotRate !== 0
					? bookingDetails.spotRateStatus
					: '',
			spotRateCode: bookingDetails.spotRateRequestId,
		},
		weightDetails: {
			uldInfoDetaills:
				bookingDetails.bookingCommodityDetails &&
					bookingDetails.bookingCommodityDetails[0].uldInfoDetaills
					? bookingDetails.bookingCommodityDetails[0].uldInfoDetaills
					: null,
			looseDetails:
				bookingDetails.bookingCommodityDetails &&
					bookingDetails.bookingCommodityDetails[0].dimensionDetaills
					? bookingDetails.bookingCommodityDetails[0].dimensionDetaills
					: null,
		},
		crates: bookingDetails?.cages ? bookingDetails.cages : [],
		additionalCommodityDetails: (dgCheck) || (dgCheckNormal && dgCheckNormal === 'true') ?
			{
				dangerousGoods: bookingDetails?.dangerousGoodsInformation ? unidInfoArray : null
			} : null
		,
		specializedCommodityAttachments: bookingDetails?.specializedCommodityAttachments,
		dgbookcheck: bookingDetails?.dangerousGoodsInformation && bookingDetails.dangerousGoodsInformation.length > 0 ? true : false,
		promoCode: bookingDetails?.uniqueReferenceFour,
		spotRateCode: bookingDetails.spotRateRequestId,
		originCityName: bookingDetails?.shipmentDetails.originCityName || '',
		destCityName: bookingDetails?.shipmentDetails.destCityName || '',
		cumulativeJourneyTime: bookingDetails?.shipmentDetails.cumulativeJourneyTime || '',
		lastAcceptanceTime: bookingDetails?.shipmentDetails.lastAcceptanceTime || '',
		earliestDeliveryTime: bookingDetails?.shipmentDetails.earliestDeliveryTime || '',
		ubrNumber: bookingDetails?.ubrNumber || '',
		isAwbDataCaptureDone: bookingDetails?.shipmentDetails?.isAWBDataCaptureDone === true,
		dangerousGoodsInformation: bookingDetails?.dangerousGoodsInformation || null,

	}

	return responseBody
}

const getFormattedDate = (dateToChange) => {
	return moment(dateToChange, 'DD-MMM-YYYY').format('ddd DD MMM')
}

const getShipmentSccs = (handlingCodes) => {
	let shipmentSccs = []
	handlingCodes.filter((handlingCode) => shipmentSccs.push(handlingCode.code))
	return shipmentSccs.toString()
}

const getService = (sccCodes) => {
	if (sccCodes.length && sccCodes.includes('XPS')) {
		return 'FastTrack'
	}
}
